"use client";

import Icon from "@/components/Icon";
import classNames from "@/helpers/classNames";
import styles from "./styles.module.scss";

export interface ProductQuantityProps {
  value: number;
  min?: number;
  max?: number;
  onChange: (value: number) => void;
  className?: string;
}

const ProductQuantity = ({ value, min = 1, max, onChange, className }: ProductQuantityProps) => (
  <div className={classNames(styles.container, className)}>
    <button
      type="button"
      className={classNames(styles.button, styles.buttonMinus)}
      onClick={() => onChange(Math.max(min, value - 1))}
      disabled={value <= min}
      aria-label="Decrease quantity"
    >
      <Icon title="minusBold" size="sm" />
    </button>
    <span className={styles.value}>{value}</span>
    <button
      type="button"
      className={classNames(styles.button, styles.buttonPlus)}
      onClick={() => onChange(max ? Math.min(max, value + 1) : value + 1)}
      disabled={max != null && value >= max}
      aria-label="Increase quantity"
    >
      <Icon title="plusBold" size="sm" />
    </button>
  </div>
);

export default ProductQuantity;
